import { useCallback, useContext, useEffect, useState } from "react";
import { noticeApi } from "src/api/notice";
import { RequestContext } from "src/contexts/request-context";
import { NoticeModal } from "./notice-modal";
import { NoticeBanner } from "./notice-banner";

import { isNoticeDismissed, dismissNotice } from "src/utils/notice-dismissal";

export const NoticeProvider = ({ children, target = "DASHBOARD" }) => {
  const { isInitialized } = useContext(RequestContext);
  const [notices, setNotices] = useState([]);
  const [closedIds, setClosedIds] = useState(new Set());

  const loadNotices = useCallback(async () => {
    try {
      const data = await noticeApi.getActiveNotices(target);
      setNotices(data || []);
    } catch {
      // 공지 로딩 실패는 무시
    }
  }, [target]);

  useEffect(() => {
    if (target === "HOME" || isInitialized) {
      loadNotices();
    }
  }, [target, isInitialized, loadNotices]);

  const visibleNotices = notices.filter(
    (n) => !isNoticeDismissed(n.noticeId) && !closedIds.has(n.noticeId)
  );

  const modalNotices = visibleNotices.filter((n) => n.type === "MODAL");
  const bannerNotices = visibleNotices.filter((n) => n.type === "BANNER");

  const currentModal = modalNotices[0] || null;

  const handleCloseModal = () => {
    if (currentModal) setClosedIds((prev) => new Set([...prev, currentModal.noticeId]));
  };

  const handleDismissModal = (days) => {
    if (currentModal) {
      dismissNotice(currentModal.noticeId, days);
      handleCloseModal();
    }
  };

  const handleCloseBanner = (noticeId) => {
    setClosedIds((prev) => new Set([...prev, noticeId]));
  };

  const handleDismissBanner = (noticeId, days) => {
    dismissNotice(noticeId, days);
    setClosedIds((prev) => new Set([...prev, noticeId]));
  };

  return (
    <>
      <NoticeBanner
        notices={bannerNotices}
        onClose={handleCloseBanner}
        onDismiss={handleDismissBanner}
      />
      {children}
      <NoticeModal
        notice={currentModal}
        onClose={handleCloseModal}
        onDismiss={handleDismissModal}
      />
    </>
  );
};
